(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["influencer-product-request"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sz-influencer-request]').forEach(function (requestSection) {
      var link = requestSection.querySelector('[data-sz-request-link]');
      if (!link || link.dataset.szReady === 'true') return;
      link.dataset.szReady = 'true';

      link.addEventListener('click', function () {
        var productArea = requestSection.previousElementSibling;
        var variantInput = productArea ? productArea.querySelector('form[action*="/cart/add"] [name="id"]') : null;
        // The CTA is placed as its own section in templates/product.json, so the
        // buy box is not a DOM sibling. Fall back to the main product section.
        if (!variantInput) {
          variantInput = document.querySelector('.product-single form[action*="/cart/add"] [name="id"]');
        }
        var variantId = variantInput ? variantInput.value : requestSection.dataset.initialVariantId;
        var variantTitle = '';

        if (variantInput && variantInput.tagName === 'SELECT' && variantInput.selectedIndex >= 0) {
          variantTitle = variantInput.options[variantInput.selectedIndex].text;
        } else if (variantId === requestSection.dataset.initialVariantId) {
          variantTitle = requestSection.dataset.initialVariantTitle;
        }

        var params = new URLSearchParams();
        params.set('product_name', requestSection.dataset.productName || '');
        params.set('product_url', requestSection.dataset.productUrl || window.location.href.split('?')[0]);
        params.set('product_id', requestSection.dataset.productId || '');
        params.set('product_sku', requestSection.dataset.initialVariantSku || '');
        if (variantId) params.set('variant_id', variantId);
        if (variantTitle) params.set('variant_title', variantTitle.trim());
        link.href = '/pages/under-the-influence-product-request?' + params.toString();
      });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-protection-decline"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-shipping-protection-decline]';
    let protectedCheckoutPending = false;

    const update = (container) => {
      const checkbox = container.querySelector('[data-shipping-protection-decline-checkbox]');
      if (!checkbox) return;

      const accepted = checkbox.checked;
      const protectedCheckout = container.getAttribute('data-shipping-protection-in-cart') === 'true';
      const checkoutAllowed = accepted || protectedCheckout;
      const form = container.closest('form');

      container.querySelectorAll('[data-shipping-protection-audit-field]').forEach((field) => {
        field.disabled = !accepted;
        if (!field.hasAttribute('data-shipping-protection-timestamp')) {
          field.value = accepted ? field.getAttribute('data-audit-value') : '';
        }
      });

      const timestamp = container.querySelector('[data-shipping-protection-timestamp]');
      if (timestamp) timestamp.value = accepted ? new Date().toISOString() : '';

      if (form) {
        form.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
          button.disabled = !checkoutAllowed;
          button.setAttribute('aria-disabled', checkoutAllowed ? 'false' : 'true');
        });
        form.querySelectorAll('[data-cart-checkout-buttons]').forEach((checkoutButtons) => {
          checkoutButtons.classList.toggle('cart__buttons--disabled', !checkoutAllowed);
        });
      }
    };

    const initialize = (root = document) => {
      root.querySelectorAll(selector).forEach(update);
    };

    const syncProtectionState = async () => {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin' });
        const cart = await response.json();
        const protectedCheckout = cart.items.some((item) => item.handle === 'insureshield-shipping-insurance-product');
        document.querySelectorAll(selector).forEach((container) => {
          container.setAttribute('data-shipping-protection-in-cart', protectedCheckout ? 'true' : 'false');
          update(container);
        });
        if (protectedCheckout) protectedCheckoutPending = false;
      } catch (error) {
        protectedCheckoutPending = false;
      }
    };

    document.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-shipping-protection-decline-checkbox]');
      if (!checkbox) return;
      const container = checkbox.closest(selector);
      if (container) {
        update(container);
        requestAnimationFrame(() => update(container));
      }
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.checkout-cart-widget')) return;
      protectedCheckoutPending = true;
      window.setTimeout(syncProtectionState, 750);
      window.setTimeout(syncProtectionState, 2000);
    }, true);

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      const form = submitter.closest('form');
      const checkbox = form && form.querySelector('[data-shipping-protection-decline-checkbox]');
      const container = checkbox && checkbox.closest(selector);
      const protectedCheckout = container && container.getAttribute('data-shipping-protection-in-cart') === 'true';
      const checkoutAllowed = protectedCheckoutPending || protectedCheckout;
      protectedCheckoutPending = false;
      if (checkbox && !checkbox.checked && !checkoutAllowed) {
        event.preventDefault();
        checkbox.focus();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(selector)) update(node);
          initialize(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sz-campaign-pages"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sz-offers')){
customElements.define('sz-offers',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;
  const source=this.querySelector('.sz-campaign__source'),grid=this.querySelector('.sz-campaign__coupon-grid'),finds=this.querySelector('.sz-campaign__finds-grid');
  if(!source||!grid)return;
  const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text)n.textContent=text;return n;};
  const coupons=[];
  source.querySelectorAll('li').forEach(li=>{
   const match=li.textContent.trim().match(/^(.+?)\s+(\d+(?:\.\d+)?%)\s+Off\s*[-–—]\s*(\S+)/i);
   if(!match)return;
   const [,brand,amount,code]=match;
   const card=el('article','sz-campaign__coupon');card.dataset.search=(brand+' '+code).toLowerCase();
   card.append(el('h3','',brand),el('p','sz-campaign__amount',amount+' OFF'));
   const row=el('div','sz-campaign__code-row'),value=el('code','',code),button=el('button','','Copy code');button.type='button';button.setAttribute('aria-label','Copy '+code);
   button.addEventListener('click',async()=>{const status=this.querySelector('.sz-campaign__copy-status');try{await navigator.clipboard.writeText(code);status.textContent=code+' copied. Paste it at checkout.';button.textContent='Copied ✓';}catch{status.textContent='Your code is '+code+'. Select and copy it to use at checkout.';}});
   row.append(value,button);card.append(row);
   const link=el('a','','Shop '+brand+' ↗');link.href='/search?type=product&q='+encodeURIComponent(brand);card.append(link);grid.append(card);coupons.push(card);
  });
  if(!coupons.length)return;
  source.querySelectorAll('a').forEach(a=>{
   const img=a.querySelector('img');if(!img)return;
   const raw=a.getAttribute('href')||'';let url;try{url=new URL(raw,location.origin);}catch{return;}
   const good=/^https?:$/.test(url.protocol)&&(/^\/(products|collections|search)(\/|$)/.test(url.pathname));
   let title=a.getAttribute('title')||img.getAttribute('alt')||'';
   if(!title&&good){title=decodeURIComponent(url.pathname.split('/').pop()||'').replace(/-/g,' ');}
   if(!title||title==='search')title=good?(url.searchParams.get('q')||'Explore this featured find'):'Ask about this featured item';
   title=title.replace(/ at Speedzone Performance LLC/ig,'').replace(/\b\w/g,c=>c.toUpperCase());
   const card=el('article','sz-campaign__find'),imageBox=el('div','sz-campaign__find-image'),copy=el('div','sz-campaign__find-copy'),photo=img.cloneNode();
   photo.removeAttribute('style');photo.removeAttribute('width');photo.removeAttribute('height');photo.loading='lazy';photo.alt=title;
   imageBox.append(photo);copy.append(el('h3','',title));const link=el('a','',good?'VIEW DETAILS ↗':'ASK OUR TEAM ↗');link.href=good?url.href:'/pages/product-request';copy.append(link);card.append(imageBox,copy);finds.append(card);
  });
  this.querySelector('input[type=search]').addEventListener('input',e=>{const q=e.target.value.trim().toLowerCase();let count=0;coupons.forEach(c=>{c.hidden=!c.dataset.search.includes(q);if(!c.hidden)count++;});this.querySelector('.sz-campaign__empty').hidden=count!==0;});
  source.hidden=true;this.querySelector('.sz-campaign__enhanced').hidden=false;this.dataset.ready='true';
 }
});
}
  } catch(e) { console.error(e); }
})();

})();
